import { number_format } from '@/api/filter';
export const config = {
    data() {
        return {
            columns: [],
            searchParams: {
            }
        };
    },
    methods: {
        getColumns() {
            let checkInsuranceStatusMap = {
                '-2': '承保失败',
                '-5': '核保失败',
                '0': '待投保',
                '1': '待支付',
                '2': '待实收',
                '3': '待承保',
                '4': '已完成',
                '5': '核保中',
                '-9':'已失效'
            };
            this.columns = [
                {
                    title: '投保时间',
                    key: 'createTime',
                    minWidth: 160,
                    align: 'center',
                    render(h, params) {
                        let createTime = params.row.createTime && params.row.createTime.substring(0, 16);
                        return <span>{createTime}</span>;
                    }
                },
                {
                    title: '订单号',
                    key: 'orderNo',
                    minWidth: 180,
                    align: 'center'
                },
                {
                    title: '产品名称',
                    key: 'productName',
                    minWidth: 180,
                    align: 'center'
                },
                {
                    title: '投保人',
                    key: 'holderName',
                    minWidth: 140,
                    align: 'center'
                },
                {
                    title: '保费（元）',
                    key: 'fee',
                    minWidth: 140,
                    align: 'center',
                    render(h, params) {
                        return <span> {number_format(params.row.fee, 2)}</span>;
                    }
                },
                {
                    title: '订单状态',
                    key: 'checkInsuranceStatus',
                    minWidth: 140,
                    align: 'center',
                    render(h, params) {
                        if (params.row.status == 3) {
                            return <span>已退款</span>;
                        } else {
                            return <span> {checkInsuranceStatusMap[params.row.checkInsuranceStatus]}</span>;
                        }
                    }
                },
                {
                    title: '出单业务员',
                    key: 'salemanName',
                    minWidth: 180,
                    align: 'center',
                    render(h, params) {
                      return <span>{params.row.staffNo} /{params.row.salemanName}</span>;
                    }
                },
                {
                    title: '所属团队',
                    key: 'groupName',
                    minWidth: 180,
                    align: 'center',
                    render(h, params) {
                      return <span>{params.row.organizationName} /{params.row.groupName}</span>;
                    }
                },
                {
                    title: '操作',
                    slot: 'action',
                    align: 'center',
                    width: '100',
                    fixed: 'right'
                }
            ];
        }
    }
};
